"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelWidget = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var Colors_1 = require("../styles/Colors");
var TabStyles_1 = require("../styles/TabStyles");
var ReactHelpers_1 = require("../utils/ReactHelpers");
var FontSize = TabStyles_1.TabStyles.Typography.Sizing.Default;
var LabelStyleName = TypeStyle.style({
    color: Colors_1.TextColors.Secondary,
    fontSize: FontSize,
    height: "21px",
    lineHeight: "21px",
    $nest: {
        '&.dark': { color: Colors_1.InvertTextColors.Secondary },
    }
});
/** @private not intended for external use */
exports.LabelWidget = function (props) {
    var useDarkStyling = props.useDarkStyling, divProps = tslib_1.__rest(props, ["useDarkStyling"]);
    var handleClick = React.useCallback(function (e) {
        var _a;
        if (!e.currentTarget.htmlFor) {
            return;
        }
        var focusTarget = document.getElementById(e.currentTarget.htmlFor);
        if (focusTarget && !(focusTarget.tabIndex === null || focusTarget.tabIndex === undefined)) {
            focusTarget.focus();
        }
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }, [props.onClick]);
    return (React.createElement("label", tslib_1.__assign({}, divProps, ReactHelpers_1.EventUtilsOptOut, { className: TypeStyle.classes(LabelStyleName, props.className, useDarkStyling && 'dark'), onClick: handleClick })));
};
//# sourceMappingURL=LabelWidget.js.map